export default "__VITE_PUBLIC_ASSET__47597b09__"